import { ApiCustomer } from '@vend/types'
import { useLineItemFulfillmentContext } from '../LineItemFulfillmentContext'
import { EMAIL_REGEX } from '../../../../../../constants'

export const useLineItemFulfillmentCustomerDetailsChange = () => {
  const {
    setCurrentCustomer,
    setIsEmailInvalid,
  } = useLineItemFulfillmentContext()

  const handleFirstNameChange = (newFirstName: string) => {
    setCurrentCustomer(
      (prevState: ApiCustomer | null) =>
        ({
          ...(prevState || {}),
          first_name: newFirstName,
        } as ApiCustomer)
    )
  }

  const handleLastNameChange = (newLastName: string) => {
    setCurrentCustomer(
      (prevState: ApiCustomer | null) =>
        ({
          ...prevState,
          last_name: newLastName,
        } as ApiCustomer)
    )
  }

  const handleEmailChange = (newEmail: string) => {
    setCurrentCustomer(
      prevState =>
        ({
          ...prevState,
          email: newEmail,
        } as ApiCustomer)
    )
    setIsEmailInvalid(newEmail.length > 0 && !newEmail.match(EMAIL_REGEX))
  }

  const handlePhoneNumberChange = (
    phoneNumberType: string,
    phoneNumber: string
  ) => {
    setCurrentCustomer(
      prevState =>
        ({
          ...prevState,
          [phoneNumberType]: phoneNumber,
        } as ApiCustomer)
    )
  }

  return {
    handleFirstNameChange,
    handleLastNameChange,
    handleEmailChange,
    handlePhoneNumberChange,
  }
}
